import { injectable } from 'inversify';
import { action, computed, makeObservable, observable } from 'mobx';

export enum Tools {
  NONE = 0,
  Delete = 1,
  Distance = 2,
  Angle = 3,
  Annotation = 4,
  Area = 5,
  Spline = 6
}

@injectable()
export class ToolStateStore {
  @observable
  private _currentTool: Tools = Tools.NONE;

  public constructor() {
    makeObservable(this);
  }

  @computed
  public get currentTool(): Tools {
    return this._currentTool;
  }

  @action
  public setCurrentTool(tool: Tools): void {
    if (this._currentTool === tool) {
      this._currentTool = Tools.NONE;
    } else this._currentTool = tool;
  }
}
